<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->
<ng-container *ngIf="initialized$ | async">
    <div class="wrapper" appLifecycleTracker trackerName="administration">
        <mat-card appearance="raised" *ngIf="isAdmin()" (click)="moveUser()">
            <button mat-flat-button [disableRipple]="true" appButtonFocusRemover aria-label="Move a user.">
                <span class="mdi mdi-account-star"></span>
                {{ 'ADM_MOVEU' | translate }}
            </button>
        </mat-card>

        <mat-card appearance="raised" *ngIf="isAdmin()" (click)="manageGroups()">
            <button mat-flat-button [disableRipple]="true" appButtonFocusRemover aria-label="Manage groups for users.">
                <span class="mdi mdi-account-group"></span>
                {{fManageUser}}
            </button>
        </mat-card>

        <mat-card appearance="raised" *ngIf="isAdmin()" (click)="reparentGroup()" >
            <button mat-flat-button [disableRipple]="true" appButtonFocusRemover aria-label="Re-parent a group.">
                <span class="mdi mdi-account-group"></span>
                {{'ADM_REPARENT' | translate}}
            </button>
        </mat-card>

        <mat-card appearance="raised" *ngIf="isAdmin()" (click)="addAdminEvent()">
            <button mat-flat-button [disableRipple]="true" appButtonFocusRemover aria-label="Add an admin event.">
                <span class="mdi mdi-calendar-plus"></span>
                {{'CREATE_ADMIN_EVENT_BUTTON' | translate}}
            </button>
        </mat-card>

        <mat-card appearance="raised" *ngIf="isAdmin()" (click)="deleteOrganization()">
            <button mat-flat-button [disableRipple]="true" appButtonFocusRemover aria-label="Delete an Organization.">
                <span class="mdi mdi-delete"></span>
                {{'ORG_DELETE' | translate}}
            </button>
        </mat-card>

        <mat-card appearance="raised">
            <div *ngIf="usersStats">
                <table aria-label="User statistics">
                    <tbody>
                        <tr>
                            <th scope="row" class="left">
                                {{fRecent}}
                            </th>
                            <td class="right">
                                {{ usersStats.recent_logins }}
                            </td>
                        </tr>
                        <tr>
                            <th scope="row" class="left">
                                {{fTotalUsers}}
                            </th>
                            <td class="right">
                                {{ usersStats.total_users }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
    </div>

    <mat-tab-group>

        <mat-tab>
            <ng-template mat-tab-label>
                Licenses in Use
            </ng-template>
            @if (licensesUsed$ | async; as licensesUsed) {
                @for (msp of Object.keys(licensesUsed); track $index) {
                    <h1 style="margin-top: 1.5em">MSP: {{ msp }}</h1>
                    @for (cust of Object.keys(licensesUsed[msp]); track $index) {
                        <h2 style="margin-top: 1em">Customer: {{ cust }}</h2>
                        <table style="width:80%" aria-describedby="Admin Table">
                            <thead>
                            <tr>
                                <th style="text-align: left; width:18%">Subscription</th>
                                <th style="text-align: left; width:18%">Plan</th>
                                <th style="text-align: right">Available</th>
                                <th style="text-align: right">Data Defense</th>
                                <th style="text-align: right">PBA</th>
                            </tr>
                            </thead>
                            <tbody>
                            @for (used of licensesUsed[msp][cust]; track $index) {
                                <tr>
                                    <td style="width:18%">{{ used.sub_id }}</td>
                                    <td style="width:18%">{{ used.plan_id }}</td>
                                    <td style="text-align: right">{{ used.avail }}</td>
                                    <td style="text-align: right">{{ used.dd_used }}</td>
                                    <td style="text-align: right">{{ used.pba_used }}</td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    }
                }
            }
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{fUsers}}
            </ng-template>

            <div *ngIf="users.length === 0">
                <h2>{{fNone}}</h2>
            </div>

            <div *ngIf="users.length > 0" class="users-table">
                <mat-table [dataSource]="users" class="mat-elevation-z8">
                    <ng-container matColumnDef="username">
                        <mat-header-cell *matHeaderCellDef>{{fUsername}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)"> {{element.username}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="company">
                        <mat-header-cell *matHeaderCellDef>{{fCompany}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)"> {{element.company || '-'}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="administrator">
                        <mat-header-cell *matHeaderCellDef>{{fAdmin}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.administrator"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="active">
                        <mat-header-cell *matHeaderCellDef>{{fActive}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.active"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="advanced_features">
                        <mat-header-cell *matHeaderCellDef>{{fAdvA}}<br/>{{fAdvB}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.advance_features"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="business_edition">
                        <mat-header-cell *matHeaderCellDef>{{fD3EA}}<br/>{{fD3EB}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.business_edition"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="create_child">
                        <mat-header-cell *matHeaderCellDef>{{fCreate}}<br/>{{fChild}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.create_child"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="manage_child">
                        <mat-header-cell *matHeaderCellDef>{{fManage}}<br/>{{fChild}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            <span class="mdi mdi-check" *ngIf="element.manage_child"></span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="password_exp">
                        <mat-header-cell *matHeaderCellDef>{{fPassExpire}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">{{ element.password_exp | date : 'short' }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="locked_until">
                        <mat-header-cell *matHeaderCellDef>{{fLocked}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">{{ element.locked_until | date : 'short' }}</mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="usersTableColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: usersTableColumns;" class="clickable highlight"></mat-row>
                </mat-table>
            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{fExpiringSub}}
            </ng-template>

            <div *ngIf="subs.length === 0">
                <h2>{{fNone}}</h2>
            </div>

            <div class="admin-table" *ngIf="subs.length > 0">
                <mat-table [dataSource]="subs" class="mat-elevation-z8 expired-subs-table">
                    <ng-container matColumnDef="groupName">
                        <mat-header-cell *matHeaderCellDef>{{'ORG_NAME' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.group.name}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="contactEmail">
                        <mat-header-cell *matHeaderCellDef>{{fEmail}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.group.contact_email}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="subscription_id">
                        <mat-header-cell *matHeaderCellDef>{{fSubID}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.subscription.subscription_id}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="exp_timestamp">
                        <mat-header-cell *matHeaderCellDef>{{fExpireDate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.subscription.exp_timestamp | date}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="latest_endpoint_dttm">
                        <mat-header-cell *matHeaderCellDef>{{'administration.expiring.last-endpoint-activity' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.subscription.latest_endpoint_dttm | date}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="exp_edit_icon">
                        <mat-header-cell *matHeaderCellDef>{{'L_ACTIONS' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span class="mdi mdi-calendar clickable row-icon"
                                matTooltip="{{'EE_HEADER' | translate}}"
                                matTooltipShowDelay="500"
                                matTooltipPosition="above"
                                (click)="editExpDate(element)"
                                (keyup.enter)="editExpDate(element)"></span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="subsTableColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: subsTableColumns;"></mat-row>
                </mat-table>
            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{fActiveIntegrations}}
            </ng-template>

            <div *ngIf="activeIntegrations.length === 0">
                <h2>{{fNone}}</h2>
            </div>

            <div class="admin-table" *ngIf="activeIntegrations.length > 0">
                <mat-table [dataSource]="activeIntegrations" class="mat-elevation-z8">
                    <ng-container matColumnDef="adminEmail">
                        <mat-header-cell *matHeaderCellDef>{{fUsername}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.admin_email}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="partnerId">
                        <mat-header-cell *matHeaderCellDef>{{fPartner}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{getPartnerName(element.partner_id)}}</mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="activeIntegrationsTableColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: activeIntegrationsTableColumns;"></mat-row>
                </mat-table>
            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{fSuperUser}}
            </ng-template>

            <div *ngIf="superusers.length === 0">
                <h2>{{fNone}}</h2>
            </div>

            <div class="admin-table" *ngIf="superusers.length > 0">
                <mat-table [dataSource]="superusers" class="mat-elevation-z8">
                    <ng-container matColumnDef="username">
                        <mat-header-cell *matHeaderCellDef>{{fUsername}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.username}} </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="superusersTableColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: superusersTableColumns;"></mat-row>
                </mat-table>
            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{fAdministrator}}
            </ng-template>

            <div *ngIf="administrators.length === 0">
                <h2>{{fNone}}</h2>
            </div>

            <div class="admin-table" *ngIf="administrators.length > 0">
                <mat-table [dataSource]="administrators" class="mat-elevation-z8">
                    <ng-container matColumnDef="username">
                        <mat-header-cell *matHeaderCellDef>{{fUsername}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)"> {{element.username}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef>{{fEmail}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)"> {{element.email}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="company">
                        <mat-header-cell *matHeaderCellDef>{{fCompany}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)"> {{element.company || '-'}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="admin_type">
                        <mat-header-cell *matHeaderCellDef>{{fType}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" (click)="onUserRowClick(element)">
                            {{ getAdminType(element) }}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="administratorsTableColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: administratorsTableColumns;" class="clickable highlight"></mat-row>
                </mat-table>
            </div>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                {{'admin.org-tree.tab-label' | translate}}
            </ng-template>
            <app-orgs-overview></app-orgs-overview>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                Simulate Exception
            </ng-template>
            Trigger an Exception
            <mat-form-field>
                <mat-label>Message</mat-label>
                <input type="text" matInput #exceptionMessage>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="raiseException(exceptionMessage.value)">Raise</button>

        </mat-tab>

    </mat-tab-group>

</ng-container>

